export default function CheckboxDashIcon({
    style,
}) {
    return <svg style={{ position: "absolute", top: "3px", left: "3px", ...style }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="14" height="14" rx="1"></rect><path d="M3.21157 7H10.9999" stroke="white" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
}